import React from 'react';
import { Flashy, Icon, Layout } from '@axiom/ui';
import { CandidateOpportunityUtils } from '@axiom/utils';
import { CandidateOpportunitiesConst } from '@axiom/const';
import { string } from 'prop-types';

import { CandidateOpportunityShape } from '../../models/candidate-opportunity';
import { CandidateRateUtil } from '../../utils/candidate-rate-util';

const { CandidateStatuses } = CandidateOpportunitiesConst;

export const CpqMarginIndicator = ({ candidateOpportunity, name }) => {
  if (!candidateOpportunity?.position?.id) {
    return <div data-test={name} />;
  }

  const { clientRequest } = candidateOpportunity;

  if (
    (candidateOpportunity.candidateStatus === CandidateStatuses.Rejected &&
      clientRequest?.candidateOpportunityStatus ===
        CandidateStatuses.Rejected) ||
    !CandidateRateUtil.hasSubmittedRate(candidateOpportunity)
  ) {
    return (
      <Flashy color="dataVizGray" name="RATE_NOT_SET">
        <Layout position="middle">
          <Icon name="circle-check-filled" />
        </Layout>
      </Flashy>
    );
  }

  if (!CandidateOpportunityUtils.isWithinMargin(candidateOpportunity)) {
    return (
      <Flashy color="dataVizYellow" name="RATE_OUTSIDE_GUIDELINES">
        <Layout position="middle">
          <Icon name="alert-filled" />
        </Layout>
      </Flashy>
    );
  }

  if (CandidateOpportunityUtils.isOverMargin(candidateOpportunity)) {
    return (
      <Flashy color="dataVizYellow" name="MARGIN_OVER_GUIDELINES">
        <Layout position="middle">
          <Icon name="alert-filled" />
        </Layout>
      </Flashy>
    );
  }

  return (
    <Flashy color="iconAssistant" name="RATE_WITHIN_GUIDELINES">
      <Layout position="middle">
        <Icon name="circle-check-filled" />
      </Layout>
    </Flashy>
  );
};

CpqMarginIndicator.defaultProps = {
  candidateOpportunity: {},
};

CpqMarginIndicator.propTypes = {
  candidateOpportunity: CandidateOpportunityShape,
  name: string,
};
